import { FC } from 'react';
import { useIntl } from 'react-intl';

import { ProductStateStatus } from '@/shared/api/protocol-ts/api/billing_new/dto_product_new_pb';
import { useAppSelector } from '@/shared/hooks';

import { billingModel } from '@/entities/billing';

import { NoSubscription } from '../NoSubscription/NoSubscription';
import { SubscriptionCard } from '../SubscriptionCard/SubscriptionCard';

type SubscriptionsProps = {
  className?: string;
  isCISCluster: boolean;
  openShop: () => void;
};

export const Subscriptions: FC<SubscriptionsProps> = (props) => {
  const { className, isCISCluster, openShop } = props;

  const { formatMessage } = useIntl();

  const currentSubscription = useAppSelector(
    billingModel.selectors.selectCurrentSubscription,
  );
  const scheduledSubscription = useAppSelector(
    billingModel.selectors.selectScheduledSubscription,
  );
  const currentOnOpenShop = isCISCluster ? openShop : undefined;
  const scheduledOnOpenShop =
    !currentSubscription && scheduledSubscription && isCISCluster
      ? openShop
      : undefined;

  return (
    <>
      {currentSubscription && (
        <SubscriptionCard
          className={className}
          onOpenShop={currentOnOpenShop}
          subscription={currentSubscription}
          title={formatMessage({
            id: 'subscription.currentSubscription.header',
            defaultMessage: 'Current Subscription',
          })}
        />
      )}

      {scheduledSubscription && (
        <SubscriptionCard
          className={className}
          onOpenShop={scheduledOnOpenShop}
          overrideStatus={
            ProductStateStatus.ProductStateStatusAwaitingActivation
          }
          subscription={scheduledSubscription}
          title={formatMessage({
            id: 'subscription.scheduledSubscription.header',
            defaultMessage: 'Scheduled Subscription',
          })}
          showPaymentReminder={false}
        />
      )}

      {!currentSubscription && !scheduledSubscription && (
        <SubscriptionCard
          className={className}
          title={formatMessage({
            id: 'subscription.currentSubscription.header',
            defaultMessage: 'Current Subscription',
          })}
        >
          <NoSubscription />
        </SubscriptionCard>
      )}
    </>
  );
};
